// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2kaKN","label":"LabeledBox_label__2RFJB"};